import React from 'react';
import BCPGuideSection from '../components/BCPGuideSection';
import ToggleAccordion from '../components/ToggleAccordion';
import type { BCPSectionConfig } from './bcpFieldConfig';

export const PROCEDURE_MANUAL_SECTIONS: BCPSectionConfig[] = [
  {
    id: 'procedure_overview',
    title: '手順書',
    fields: [
      {
        id: 'procedure_overview_static',
        type: 'static',
        content: (
          <div className="space-y-6">
            <BCPGuideSection>
              <div className="text-sm text-gray-700 space-y-4">
                <div>
                  <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                    手順書とは
                  </h4>
                  <p className="mb-0">
                    「手順書」はミクロな視点から BCP を円滑に運用するための補助となるツール類です。手順書を併せて活用することで、平常時の準備や緊急時の迅速な対応が容易となります。 ダウンロード後に自社に合わせてカスタマイズして、必要な手順書を整備してください。
                  </p>
                  <a
                    href="/procedure-manual.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                    style={{ display: 'inline-block', marginTop: '4px' }}
                  >
                    手順書の内容を確認する
                  </a>
                </div>
                <div style={{ paddingTop: '4px' }}>
                  <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                    手順書一覧
                  </h4>
                  <div
                    className="rounded text-sm text-gray-700"
                    style={{ backgroundColor: '#FFFFFF', border: '1px solid #E5E7EB', padding: '13px' }}
                  >
                    <ul style={{ listStyleType: 'disc', paddingLeft: '21px', margin: 0 }}>
                      <li style={{ marginBottom: 0 }}>全社員向け緊急時行動ガイドライン</li>
                      <li style={{ marginBottom: 0 }}>安否確認チェックリスト</li>
                      <li style={{ marginBottom: 0 }}>来訪者・来店者・災害弱者等への対応</li>
                      <li style={{ marginBottom: 0 }}>備蓄品リスト</li>
                      <li style={{ marginBottom: 0 }}>帰宅判断基準(地震編)</li>
                      <li style={{ marginBottom: 0 }}>帰宅指示判断基準(水害編)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </BCPGuideSection>
          </div>
        ),
      },
    ],
  },
  {
    id: 'stockpile_list',
    title: '備蓄品リスト',
    fields: [
      {
        id: 'stockpilePlan',
        label: '備蓄品リスト',
        type: 'textarea',
        minHeight: 'medium',
        placeholder: '備蓄品リストを入力してください',
        aiConsult: true,
      },
      {
        id: 'subsidy_guide',
        type: 'static',
        content: (
          <div style={{ marginTop: '24px' }}>
            <ToggleAccordion title="記入ガイドを表示" defaultOpen={false}>
              <BCPGuideSection>
                <div>
                  <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                    補助金／助成金の活用
                  </h4>
                  <p className="text-sm text-gray-700 mb-0" style={{ lineHeight: '20px' }}>
                    備蓄物資の購入に補助金／助成金を活用できる場合があるので、必要に応じて事前に確認しましょう。
                  </p>
                  <p className="text-sm text-gray-700" style={{ lineHeight: '20px' }}>
                    <span>参考ページ: </span>
                    <a
                      href="https://mirasapo-plus.go.jp/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      https://mirasapo-plus.go.jp/
                    </a>
                  </p>
                </div>
              </BCPGuideSection>
            </ToggleAccordion>
          </div>
        ),
      },
    ],
  },
];

export type ProcedureManualFieldId =
  (typeof PROCEDURE_MANUAL_SECTIONS)[number]['fields'][number]['id'];
